import CustomForm from "../../../components/form/CustomForm";
import PageWrapper from "../../../components/layouts/PageWrapper";
import { useCallback, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { productTagSchema } from "../../../helpers/validation-schemas/product/product-tag.schema";
import { TProductTag } from "../../../types/product/TProductTag";
import { useUpdateProductTagMutation } from "../../../states/product/product-tag.api";
import { useErrorHandling } from "../../../hooks/useErrorHandling";
import { castTypeArr } from "../../../utils/general/cast-type";
import { TFailResponse } from "../../../types/general/TFailResponse";
import { productTagFields } from "../../../helpers/fields/product/product-tag.fields";
import { removeKeys } from "../../../utils/general/removeKeys";
import { Toast } from "../../../helpers/popups/Toast";
import { PRODUCT_TAG } from "../../../utils/constants/product-tag.constants";
import { LoadingSpinner } from "../../../components/layouts/LoadingSpinner";
import AuthComponent from "@components/auth/component";
import { userRoleSchema } from "@helpers/validation-schemas/user-management/user-role.schema";
import { TUserRole } from "../../../types/user-management/TUserRole";
import { useUpdateUserRoleMutation } from "../../../states/user-management/user-role.api";
import { userRoleFields } from "../../../helpers/fields/user-management/user-role.fields";
import { USER_ROLE } from "@utils/constants/user-role.constants";

const UserRoleEditPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const { userRole } = location.state as {
    userRole: TUserRole;
  };

  const [updateUserRole, { isLoading, error: updateError, isSuccess }] =
    useUpdateUserRoleMutation();

  useErrorHandling(...castTypeArr<TFailResponse>([updateError]));

  const fields = useMemo(() => {
    return userRoleFields();
  }, []);

  const asyncDispatcher = useCallback(
    async (reqBody: any) => {
      try {
        const rest = removeKeys(reqBody, "remark");
        const res = await updateUserRole({
          id,
          body: { ...rest },
        });

        const successData = "data" in res ? res.data : null;
        const { success, message } = successData;

        if (success || isSuccess) {
          Toast.fire({
            title: message,
            icon: "success",
          });

          navigate(USER_ROLE.BASE_PATH, {
            state: {
              reload: true,
            },
          });
        }
      } catch (error) {
        console.log("Error", error);
      }
    },
    [updateUserRole, isSuccess, Toast, navigate]
  );

  return (
    <AuthComponent action="edit" module="User Management" subModule="User Role" page>
      <PageWrapper>
        {isLoading && <LoadingSpinner />}
        <CustomForm
          title="Edit User Role"
          schema={userRoleSchema}
          fields={fields}
          defaultValues={userRole}
          asyncDispatcher={asyncDispatcher}
        />
      </PageWrapper>
    </AuthComponent>
  );
};

export default UserRoleEditPage;
